import $ from 'jquery'
import { deserialize } from './utils/json.js'

let initialLinkHref

const init = async () => {
  setupDropdowns()
  setupButton()
}

const setupDropdowns = () => {
  const $dropdowns = $('select.contact-dropdown')
  $dropdowns.first().closest('.row').removeClass('d-none')
  $dropdowns.change(function () {
    renderAction($(this))
  })

  return $dropdowns
}

const setupButton = () => {
  const $buttonLink = getLinkAnchor()
  $buttonLink.addClass('inactive')
  initialLinkHref = $buttonLink.attr('href')
}

const renderAction = ($changedDropdown) => {
  resetButton()
  hideAllReachableChildDropdowns($changedDropdown)

  let selectedOption = deserialize($changedDropdown.val())
  if (!selectedOption.type || !selectedOption.value) return

  switch (selectedOption.type) {
    case 'externalLink':
    case 'internalLink': {
      activateButtonWithLink(selectedOption.value)
      break
    }
    case 'dropdownReference': {
      showDropdown(selectedOption.value)
      break
    }
    default:
      break
  }
}

const resetButton = () => {
  const $buttonLink = getLinkAnchor()
  $buttonLink.addClass('inactive')
  $buttonLink.attr('href', initialLinkHref)
}

const activateButtonWithLink = (link) => {
  const $buttonLink = getLinkAnchor()
  $buttonLink.removeClass('inactive')
  $buttonLink.attr('href', link)
}

const hideAllReachableChildDropdowns = ($changedDropdown) => {
  $changedDropdown.find('option').each((index, option) => {
    const value = $(option).val()
    if (value === 'default') return

    const selectedOption = deserialize(value)
    if (!selectedOption.type || !selectedOption.value) return

    if (selectedOption.type === 'dropdownReference') {
      hideDropdown(selectedOption.value)
      hideAllReachableChildDropdowns($('select#contact-dropdown-' + selectedOption.value))
    }
  })
}

const hideDropdown = (reference) => {
  const $dropdown = $('select#contact-dropdown-' + reference)
  $dropdown.closest('.row').addClass('d-none')
  $dropdown.val('default')
}

const showDropdown = (reference) => {
  const $dropdown = $('select#contact-dropdown-' + reference)
  $dropdown.closest('.row').removeClass('d-none')
}

const getLinkAnchor = () => {
  return $('div.continue > div.btn-box').first().find('a.btn').first()
}

export default {
  init
}
